<div class="container">
    <div class="card" >
        <div class="row">
            <div class="col-md-4 offset-1">
                <figure><img src="assets/logo.png" alt="sing up image"></figure>
                 <a routerLink="../register"   style="color:white;font-size: 1.5em; text-decoration: none">Create an account</a>
            </div>

            <div class="col-md-5 offset-1">
                <p class="text-danger h2" align="center"><b>SIGN IN</b></p>
                <form  class="register-form"  id="login-form">
                            <div class="form-group">
                                <input type="text" class="form-group form-control" [(ngModel)]="userName"   name="username"  placeholder="username"/><br>
                            </div>
                            <div class="form-group">
                                <input type="password" class="form-group form-control" [(ngModel)]="password" name="password"  placeholder="Password"/>
                            </div><br>

                            <!-- <mat-form-field appearance="legacy" class="col-12"> 
                                <mat-label>Username</mat-label>
                                <input matInput  [(ngModel)]="userName" >
                              </mat-form-field> <br> <br>
                            
                              <mat-form-field appearance="standard" class="col-12">
                                <mat-label>Password</mat-label>
                                <input matInput  [(ngModel)]="password" >
                              </mat-form-field><br><br> -->
                            
                            <div class="form-group form-button" align="center">
                                <input type="submit" (click)="submitUser()" name="submit" style="background-color:#7F0026; color:white"  class="form-submit btn btn" value="Login"/>
                            </div>
                        </form>
                         
            </div>
        </div>
    </div>
</div>
